import type { MeterReadingWhere } from "@tillix/db/validators/MeterReadingWhere";
import { ExtendedModel } from "mobx-keystone";
import { api } from "../../../orpc/client";
import { createTStore, type TStoreInit } from "../../lib/models/create-t-store";
import { TStore } from "../../lib/models/t-store";
import { MeterReadingModel } from "./model.meter-reading";
import { meterReadingNS } from "./ns.meter-reading";

type MeterReadingWhereInput = typeof MeterReadingWhere.infer;

@meterReadingNS.store
export class MeterReadingStore extends ExtendedModel(
  TStore<
    MeterReadingModel,
    MeterReadingWhereInput,
    typeof api.pluginData.utilities.meterReading
  >,
  {},
) {
  Model = MeterReadingModel;
  api = api.pluginData.utilities.meterReading;

  readingsForMeterIds(meterIds: string[]): MeterReadingModel[] {
    if (meterIds.length === 0) {
      return [];
    }
    return this.data.filter((reading) => meterIds.includes(reading.meterId));
  }
}

export const createMeterReadingStore = (
  incomingData?: TStoreInit<MeterReadingModel, MeterReadingStore>,
) =>
  createTStore<MeterReadingModel, MeterReadingStore>(
    MeterReadingStore,
    incomingData,
  );
